import {createSlice, createAsyncThunk, PayloadAction} from "@reduxjs/toolkit";
import {CustomStatusUrl} from "../config/api.ts";
import axios from "axios";
import { getUserFriendlyError } from "@common/errorHandler.ts";

interface ConfigState {
    customStatuses: any[];
    wsConnected: number
}

const initialState: ConfigState = {
    customStatuses: [],
    wsConnected: 0
};

export const fetchConfigData = createAsyncThunk<ConfigState, void>(
    "config/fetchConfigData",
    async (_, {rejectWithValue }) => {
        try {
            const response = await axios.get(CustomStatusUrl);
            if (response.data.success) {
                return response.data.data;
            } else {
                throw new Error(response.data.message || "Failed to fetch KPI data");
            }
        } catch (error: any) {
             return rejectWithValue(getUserFriendlyError(error));
        }
    }
);

const configSlice = createSlice({
    name: "config",
    initialState,
    reducers: {
        setWSConnected: (state) => {
            state.wsConnected += 1
        },
        setWSDisconnected: (state) => {
            state.wsConnected = 0
        }
    },
    extraReducers: (builder) => {
        builder.addCase(
            fetchConfigData.fulfilled,
            (state, action: PayloadAction<ConfigState>) => {
                state.customStatuses = action.payload.customStatuses;
            }
        );
    },
});
export const {setWSConnected,setWSDisconnected} = configSlice.actions
export default configSlice.reducer;
